import React, {useEffect, useState} from "react"
import {
  DOCUMENT_PROCESSED,
  DOCUMENT_PROCESSING,
  DOCUMENT_UPLOADED
} from "../../constants/images.js"

const UploadNotification = ({files, onClose}) => {

  const [isMinimized, setIsMinimized] = useState(false)
  const [divClass, setDivClass] = useState("file-brouse-box")
  const [iconName, setIconName] = useState("keyboard_arrow_down")

  useEffect(() => {
    if (isMinimized) {
      setDivClass("file-brouse-box file-brouse-box-min")
      setIconName("keyboard_arrow_up")
    } else {
      setDivClass("file-brouse-box")
      setIconName("keyboard_arrow_down")
    }
  }, [isMinimized])

  const getProcessIcon = (isProcessed, processFailed) => {
    /** Processed */
    if (isProcessed) {
      return <img
          src={DOCUMENT_PROCESSED}
          className="icon-check-file process-icon"
          alt=""
          style={{ width: "20px" }}
          data-tip="Processed"
      />
      /** Error in processing */
    } else if (processFailed) {
      return <i
          className="material-icons icon-check-file process-failed-icon"
          data-tip="Error in processing"
      >
        cancel
      </i>
      /** Processing */
    } else {
      return <img
          src={DOCUMENT_PROCESSING}
          className="icon-check-file process-icon"
          alt=""
          style={{ width: "20px" }}
          data-tip="Processing"
      />
    }
  }

  const getFormatedFileName = fileName => {
    return (fileName || "").length > 32
        ? `${fileName.substring(0, 20)}...${fileName.substring(
            fileName.length - 9
        )}`
        : fileName
  }

  return <div className={divClass}>
    <div className="card">
      <header className="card-header">
            <span className="title">
              {
                files.filter(file => {
                  if(file.isDoctypeChanged) {
                    return file.isProcessed
                  }
                  return file.isUploaded
                }).length
              }{" "}
              Of{" "}
              {files.length}{" "}
              Complete
            </span>
        <span className="right">
              <i
                  style={{ cursor: "pointer" }}
                  className="material-icons dp48 size-t"
                  onClick={() => setIsMinimized(prevState => !prevState)}
              >
                {iconName}
              </i>
              <i
                  className="material-icons dp48 m-l-10 size-t"
                  style={{ cursor: "pointer" }}
                  onClick={onClose}
              >
                close
              </i>
            </span>
      </header>
      <div className="file-brouse-inner">
        <article className="card-body">
          {
            files.map((file, index) => <div key={index} className="progress-bar-box">
                  <div className="file-name-box">
                    <div className="file-name" data-tip={file.file.path || file.file.name}>
                      {getFormatedFileName(file.file.path || file.file.name)}
                    </div>
                    {
                      file.isUploaded &&
                      <img
                          src={DOCUMENT_UPLOADED}
                          className="icon-check-file"
                          alt=""
                          style={{width: "20px"}}
                          data-tip="Uploaded"
                      />
                    }
                    {/*{
                      file.isDoctypeChanged &&
                      getProcessIcon(file.isProcessed, file.processFailed)
                    }*/}
                  </div>
                  <div id="progressbar4" className="mdl-progress mdl-js-progress"/>
                </div>
            )
          }
        </article>
      </div>
    </div>
  </div>
}

export default UploadNotification
